export enum SpecialReportsConstants {
  NOT_IMPLEMENTED = 'specialReports/NOT_IMPLEMENTED',
  SAVE_SPECIAL_REPORT = 'specialReports/SAVE_SPECIAL_REPORT',
  GET_SPECIAL_REPORTS = 'specialReports/GET_SPECIAL_REPORTS',
  SET_SPECIAL_REPORTS = 'specialReports/SET_SPECIAL_REPORTS',
  SET_CURRENT_STEP = 'specialReports/SET_CURRENT_STEP',
  SET_CURRENT_SUB_STEP = 'specialReports/SET_CURRENT_SUB_STEP',
  SET_DATE_OCCURRED = 'specialReports/SET_DATE_OCCURRED',
  SET_DATE_REPORTED = 'specialReports/SET_DATE_REPORTED',
  SET_AUTHOR = 'specialReports/SET_AUTHOR',
  SET_RECORD_NUMBER = 'specialReports/SET_RECORD_NUMBER',
  SET_CREW = 'specialReports/SET_CREW',
  SET_BASE = 'specialReports/SET_BASE',
  SET_UNIT = 'specialReports/SET_UNIT',
  SET_SUPERVISOR = 'specialReports/SET_SUPERVISOR',
  SET_PERSONNEL_ISSUE = 'specialReports/SET_PERSONNEL_ISSUE',
  SET_SPECIAL_BASESITE = 'specialReports/SET_SPECIAL_BASESITE',
  SET_IS_URGENT = 'specialReports/SET_IS_URGENT',
  SET_IS_FLAG_REPORT = 'specialReports/SET_IS_FLAG_REPORT',
  SET_SUBJECT = 'specialReports/SET_SUBJECT',
  SET_CATEGORIES = 'specialReports/SET_CATEGORIES',
  SET_SUB_CATEGORIES = 'specialReports/SET_SUB_CATEGORIES',
  SET_CUSTOM_QUESTIONS = 'specialReports/SET_CUSTOM_QUESTIONS',
  SET_NARRATIVE = 'specialReports/SET_NARRATIVE',
  SET_COMMENTS = 'specialReports/SET_COMMENTS',
  SET_AUTO_EMAIL = 'specialReports/SET_AUTO_EMAIL',
  SET_EXTRA_EMAIL = 'specialReports/SET_EXTRA_EMAIL',
  SET_REPORT_REVIEWED_BY = 'specialReports/SET_REPORT_REVIEWED_BY',
  SET_STATUS = 'specialReports/SET_STATUS',
  SET_REPORT_TYPE = 'specialReports/SET_REPORT_TYPE',
  SET_RULE_ID = 'specialReports/SET_RULE_ID',
  ADD_SPECIAL_REPORT = 'specialReports/ADD_SPECIAL_REPORT',
  REMOVE_SPECIAL_REPORT = 'specialReports/REMOVE_SPECIAL_REPORT',
  SET_SPECIAL_REPORT = 'specialReports/SET_SPECIAL_REPORT',
  RESET_SPECIAL_REPORTS = 'specialReports/RESET_SPECIAL_REPORTS',
  RESET_SPECIAL_REPORTS_ON_CHART_EXIT = 'specialReports/RESET_SPECIAL_REPORTS_ON_CHART_EXIT',
  INITIALIZE_SPECIAL_REPORT = 'specialReports/INITIALIZE_SPECIAL_REPORT',
  DELETE_SPECIAL_REPORT = 'specialReports/DELETE_SPECIAL_REPORT',
  SET_SPECIAL_REPORTS_LIST = 'specialReports/SET_SPECIAL_REPORTS_LIST',
  SET_COMPLETED = 'specialReports/SET_COMPLETED',
}
